import Service from "../service"
import AuthService from "../AuthService"

const Med = {
  getSearch(data) {
    if(!data.year) {
      data.year = '';
    } else {
      data.year = data.year.year
    }
    if(!data.main_group) {
      data.main_group = '';
    }
    if(!data.sub_group) {
      data.sub_group = '';
    }
    console.log(data)
    return AuthService.get("/med?page="+data.dataSearch.paginate+
        "&user_id="+data.dataSearch.user_id+
        "&main_group="+data.main_group+
        "&name_en="+data.name_en+
        "&name_th="+data.name_th+
        "&spec_no="+data.spec_no+
        "&spec_code="+data.spec_code+
        "&sub_group="+data.sub_group+
        "&year="+data.year
    );
  },
  getById(id) {
    return AuthService.get(`/med/${id}`)
  },
  getOrderPDF(id) {
    window.open('http://127.0.0.1:8000/api/get-order-pdf/'+id);
    // return AuthService.get('get-order-pdf/'+id)
  }
}

export default Med
